import { getAppData } from '../../lib/api/common';
import {
	getPages,
	getPageByUri
} from '../../lib/api/pages';
import { getLatestNewsBlockItems } from '../../lib/api/news'

import Layout from '../../components/layout/Layout';
import SeoMaticHead from '../../components/common/SeoMaticHead'
import Page from '../../components/content/page/Page'
import { revalidateSeconds } from "../../lib/helpers/revalidateSeconds";


export type SubPageProps = {
	page: any
	companySiteData: any
	app: any
	dynamicData: any
}


export async function getStaticPaths() {

	// Get all companies and use as base segment
	const pages: any = await getPages()

	const paths = pages.entries.map((page: any) => {
		return {
			params: {
				uri: page.uri.split('/')
			}
		}
	})

	return {
		paths,
		fallback: 'blocking',
	}
}


export async function getStaticProps(context: any) {

	const uri: Array<string> = context?.params?.uri
	uri.unshift('p')

	// Fetch data
	const app: any = await getAppData()
	const data: any = await getPageByUri(
		uri.join('/'),
		context.preview ? context.previewData?.token : undefined
	);

	// Return 404 if no page is found
	if (!data.page) {
		return {
			notFound: true,
			revalidate: revalidateSeconds()
		}
	}

	// Check for dynamic content blocks
	const latestNewsBlocks = data.page.pageBuilder?.filter((block: any) => block.typeHandle === 'latestNews')

	// Get latest news if block is present
	const latestNews = latestNewsBlocks && latestNewsBlocks.length > 0 ? await getLatestNewsBlockItems( '*' ) : null

	return {
		props: {
			app: app,
			page: data.page,
			dynamicData: {
				news: latestNews?.news ? latestNews.news : null,
			}
		},
		revalidate: revalidateSeconds()
	}
}


export default function SubPage(props: SubPageProps) {

	const { page, app, dynamicData } = props

	return (
		<>
			<SeoMaticHead seo={page.seo} />
			<Layout
				key={page.id}
				appData={app}
				subHeader={[
					{
						id: page.id,
						title: page.title,
						uri: null
					}
				]}
			>
				<Page page={page} dynamicData={dynamicData} />
			</Layout>
		</>
	)

}
